var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"img-verify",staticStyle:{"height":"48px","width":"120px","text-align":"center"}},[_c('canvas',{ref:"verify",attrs:{"width":_vm.width,"height":_vm.height},on:{"click":_vm.handleDraw}})])
}
var staticRenderFns = []

export { render, staticRenderFns }